export default __webpack_public_path__ + "static/logo-change-writer-79a530de1ad3e808968f64f708600af7.png";